// La acción de SOFÍA que esperaba autorización: si el Owner abre el enlace sin sesión, el id se guarda acá y LoginRoute lo
// devuelve a /sofia/autorizar al entrar (mismo patrón que la autorización OAuth pendiente).
export const CLAVE_ACCION_PENDIENTE = 'feriaos.sofia.accion_pendiente';

export function guardarAccionPendiente(id) {
  try { window.sessionStorage.setItem(CLAVE_ACCION_PENDIENTE, String(id || '')); } catch (_e) { /* modo privado */ }
}

export function tomarAccionPendiente() {
  let id = '';
  try {
    id = window.sessionStorage.getItem(CLAVE_ACCION_PENDIENTE) || '';
    if (id) window.sessionStorage.removeItem(CLAVE_ACCION_PENDIENTE);
  } catch (_e) { /* modo privado */ }
  return id;
}
